import RecovrProductsSoldEqualsComparator from './RecovrProductsSoldEqualsComparator';
import AliasEqualsSelector from '../AliasEqualsSelector';
const options = () => [{
  name: 'Locator',
  value: 'locator'
}, {
  name: 'Tags',
  value: 'tags'
}].sort((a, b) => a.name.localeCompare(b.name));
export default AliasEqualsSelector.create(RecovrProductsSoldEqualsComparator, options);